import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function IterableMonoIcon(props: IconProps) {
  const id = useId();

  return (
    <Icon viewBox="0 0 21 22" {...props}>
      <Box
        as="mask"
        id={`iterable-mono-a-${id}`}
        width="21"
        height="22"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <Box as="path" fill="currentColor" d="M0 .5h21v21H0z" />
      </Box>
      <Box as="g" mask={`url(#iterable-mono-a-${id})`}>
        <Box as="g" opacity=".25">
          <Box
            as="mask"
            id={`iterable-mono-b-${id}`}
            width="17"
            height="17"
            x="6"
            y="6"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
          >
            <Box as="path" fill="#fff" d="M14.372 6.777 6.309 14.84l8.063 8.063 8.063-8.063-8.063-8.063Z" />
          </Box>
          <Box as="g" mask={`url(#iterable-mono-b-${id})`}>
            <Box as="path" fill="currentColor" d="m16.25 9.14-7.582 7.582 3.82 3.82 7.583-7.583-3.82-3.82Z" />
          </Box>
        </Box>
        <Box as="g" opacity=".25">
          <Box
            as="mask"
            id={`iterable-mono-c-${id}`}
            width="17"
            height="17"
            x="6"
            y="-1"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
          >
            <Box as="path" fill="#fff" d="M14.32-.863 6.259 7.2l8.063 8.063L22.384 7.2 14.32-.863Z" />
          </Box>
          <Box as="g" mask={`url(#iterable-mono-c-${id})`}>
            <Box as="path" fill="currentColor" d="m12.441 1.497-3.82 3.82 7.583 7.583 3.82-3.82-7.583-7.583Z" />
          </Box>
        </Box>
        <Box as="g" opacity=".15">
          <Box
            as="mask"
            id={`iterable-mono-d-${id}`}
            width="17"
            height="17"
            x="-2"
            y="6"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
          >
            <Box as="path" fill="#fff" d="m6.622 6.787-8.063 8.063 8.063 8.063 8.063-8.063-8.063-8.063Z" />
          </Box>
          <Box as="g" mask={`url(#iterable-mono-d-${id})`}>
            <Box as="path" fill="currentColor" d="m4.738 9.149-3.82 3.82 7.583 7.582 3.82-3.82L4.738 9.15Z" />
          </Box>
        </Box>
        <Box as="g" opacity=".15">
          <Box
            as="mask"
            id={`iterable-mono-e-${id}`}
            width="17"
            height="18"
            x="-2"
            y="-2"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
          >
            <Box as="path" fill="#fff" d="m6.805-1.044-8.063 8.063 8.063 8.063 8.063-8.063-8.063-8.063Z" />
          </Box>
          <Box as="g" mask={`url(#iterable-mono-e-${id})`}>
            <Box as="path" fill="currentColor" d="M8.684 1.319 1.102 8.9l3.82 3.82 7.582-7.582-3.82-3.82Z" />
          </Box>
        </Box>
        <Box
          as="path"
          fill="currentColor"
          d="M10.482.63a2.72 2.72 0 1 1 .001 5.441 2.72 2.72 0 0 1 0-5.44Zm7.68 7.71a2.72 2.72 0 1 1 0 5.443 2.72 2.72 0 1 1 0-5.442Zm-7.68 7.681a2.72 2.72 0 1 1 0 5.443 2.721 2.721 0 0 1 0-5.442ZM2.803 8.312a2.72 2.72 0 1 1 0 5.44 2.72 2.72 0 0 1 0-5.44Z"
        />
      </Box>
    </Icon>
  );
}
